(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    /* Saca el modal de la lista de regalos del contexto de apilamiento de la ficha.

     `.product-details` es `position: sticky` con `z-index: 1`, y eso crea un contexto de
     apilamiento. El overlay del modal es `position: fixed` con `z-index: 999`, pero al
     colgar de ahi dentro su z-index solo compite DENTRO de esa caja: quedaba por debajo
     del encabezado (sticky, z-index 8) y de las secciones siguientes. Resultado: el velo
     no llegaba a atenuar la pagina y el modal se leia como una lamina blanca suelta.

     No se puede arreglar con CSS sin tocar el z-index de `.product-details`, que es
     justo lo que sostiene su columna pegajosa. Asi que se mueve el contenedor del modal
     a <body>, donde `fixed` y `z-index` valen contra toda la pagina.

     Se mueve SOLO `#swym-registry-pdp-popups`, que es hermano del contenedor del boton,
     no su padre: los botones se quedan donde estan. Verificado en la pagina.

     Hay dos con ese mismo id —uno por cada instalacion de Swym, el bloque de app y el app
     embed—, de ahi el querySelectorAll. Cuando se desactive una de las dos, sobra la
     mitad y esto sigue siendo correcto.

     Swym rellena el modal desde un script inline, antes de DOMContentLoaded, asi que para
     cuando esto corre el contenido ya esta dentro y el movimiento lo conserva. */
  (function () {
    function moverModalAlBody() {
      var cajas = document.querySelectorAll('#swym-registry-pdp-popups');
      for (var i = 0; i < cajas.length; i++) {
        if (cajas[i].parentElement !== document.body) {
          document.body.appendChild(cajas[i]);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moverModalAlBody);
    } else {
      moverModalAlBody();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
